var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBauwerk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Bauwerk__Icn/40px/Legende/Bauwerk",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Bauwerk__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Bauwerk__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,12 L7,12 L7,28 L17,28 L17,24 L17.0045948,23.8248729 C17.0819345,22.2575699 18.399045,21 20,21 L20.1751271,21.0045948 C21.7424301,21.0819345 23,22.399045 23,24 L23,28 L33,28 L33,12 L28,12 L28,15 L27,15 L27,12 L21,12 L21,15 L19,15 L19,12 L13,12 L13,15 L12,15 L12,12 Z M17,14 L17,17 L23,17 L23,14 L25,14 L25,17 L30,17 L30,14 L31,14 L31,26 L25,26 L25,24 C25,21.3313781 22.9044736,19.1366372 20.2487335,19.0061011 L20.0245133,19.0003005 C17.3313781,19 15.1366372,21.0955264 15.0061011,23.7512665 L15.0003005,23.9754867 L15,26 L9,26 L9,14 L10,14 L10,17 L15,17 L15,14 L17,14 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Bauwerk__Combined-Shape-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBauwerk);
export default __webpack_public_path__ + "static/media/Bauwerk.80458a6949deacf93849d7937141f457.svg";
export { ForwardRef as ReactComponent };